export enum INTERFACE_STATUSES {
  OK = 'ok',
  DISABLED = 'disabled',
  UNPLUGGED = 'unplugged',
  WARNING = 'warning',
}

export enum INTERFACE_TYPES {
  OVSBRIDGE = 'ovsbridge',
  BRIDGE = 'bridge',
  VLAN = 'vlan',
  BONDING = 'bonding',
  INFINIBAND = 'infiniband',
  ETHERNET = 'iface'
}

export const AVAILABLE_DELETE = [
  INTERFACE_TYPES.VLAN,
  INTERFACE_TYPES.BONDING,
];

export const AVAILABLE_VLAN_TYPES = [
  INTERFACE_TYPES.OVSBRIDGE,
  INTERFACE_TYPES.ETHERNET,
  INTERFACE_TYPES.BONDING
];

export const AVAILABLE_BOND_TYPES = [
  INTERFACE_TYPES.OVSBRIDGE,
  INTERFACE_TYPES.ETHERNET,
  INTERFACE_TYPES.INFINIBAND
];

export const AVAILABLE_BOND_MODES_COMMON = [
  'balance-rr',
  'active-backup',
  'balance-xor',
  'broadcast',
  '802.3ad',
  'balance-tlb',
  'balance-alb'
];

export const AVAILABLE_BOND_MODES_OVS = [
  'active-backup',
  'balance-tcp'
];
